<template>
  <div class="flex gap-2 items-center">
    <p class="font-bold">{{ label }}</p>
    <div
      :class="[getBorderClass(modelValue), 'flex items-center bg-white w-fit border rounded-full cursor-pointer']"
      @click="update">
      <div class="relative flex items-center m-1 py-2 px-5 rounded-full transition-all duration-300">
        <i
          :class="[
            getClass(modelValue),
            modelValue ? 'translate-x-6' : 'translate-x-0',
            'absolute left-0 transition-transform duration-300 fa-regular fa-circle',
          ]"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
})

const inputValue = ref(props.modelValue)

const getBorderClass = (active) => {
  return active ? 'border-blue-600' : 'border-slate-300'
}

const getClass = (active) => {
  return active ? 'text-blue-600' : 'text-gray-300'
}

const update = () => {
  inputValue.value = !inputValue.value
  emit('update:modelValue', inputValue.value)
}

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== inputValue.value) {
      inputValue.value = newVal
    }
  }
)
</script>
